import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import GreetingSheet, { GREETING_DEFAULTS } from "@/components/GreetingCardCanvas";
import { downloadImage, printElement } from "@/lib/pdf";
import { Printer, Image as ImageIcon } from "lucide-react";

export default function GreetingCard({ order, open, onClose }) {
  const [cfg, setCfg] = useState(GREETING_DEFAULTS);

  useEffect(() => {
    if (!open) return;
    api.get("/settings/greeting", { params: { branch_id: order?.branch_id } }).then(({ data }) => setCfg({ ...GREETING_DEFAULTS, ...data })).catch(() => setCfg(GREETING_DEFAULTS));
  }, [open, order?.branch_id]);

  if (!order) return null;
  const o = order;
  const childName = o.child_name || o.aqiqah_name || "-";
  const data = { childName, father: o.father_name || "", mother: o.mother_name || "", photoUrl: o.photo_url };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-h-[92vh] max-w-5xl overflow-auto p-0">
        <DialogTitle className="sr-only">Kartu Ucapan Aqiqah {o.order_number}</DialogTitle>
        <div className="flex flex-wrap items-center justify-between gap-2 border-b border-brand-line px-6 py-4 no-print">
          <h2 className="font-serif text-xl font-bold text-brand-espresso">Kartu Ucapan <span className="text-sm font-sans font-normal text-brand-muted">(A4 Landscape · 4 Kartu)</span></h2>
          <div className="flex flex-wrap gap-2">
            <Button onClick={() => downloadImage("greeting-print", `kartu-ucapan-${o.order_number}.jpg`)} data-testid="jpg-greeting-btn"
              variant="outline" className="gap-2 border-brand-line">
              <ImageIcon className="h-4 w-4" /> JPG
            </Button>
            <Button onClick={() => printElement("greeting-print", { landscape: true })} data-testid="print-greeting-btn"
              className="gap-2 bg-brand-gold text-brand-espresso hover:bg-brand-goldhover">
              <Printer className="h-4 w-4" /> Cetak
            </Button>
          </div>
        </div>

        <div className="flex justify-center overflow-auto bg-brand-surface p-4">
          <div style={{ transform: "scale(0.62)", transformOrigin: "top center" }}>
            <GreetingSheet id="greeting-print" cfg={cfg} data={data} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
